import React, { Component } from 'react';
import { Styles } from '../styles/courseCategory.js';

class CourseCategory extends Component {

    render() {
        return (
            <Styles>
                {/* Course Tag */}
                <div className="course-category">
                    <h5>Course Category</h5>
                    <ul className="category-item list-unstyled">

                        <li className="check-btn">
                            <label htmlFor="cat1">
                                <input type="checkbox" id="cat1" className="check-box" />
                                Engineering<span>(30)</span>
                            </label>
                        </li>

                        <li className="check-btn">
                            <label htmlFor="cat2">
                                <input type="checkbox" id="cat2" className="check-box" />
                                Management<span>(20)</span>
                            </label>
                        </li>

                        <li className="check-btn">
                            <label htmlFor="cat3">
                                <input type="checkbox" id="cat3" className="check-box" />
                                Commerce<span>(18)</span>
                            </label>
                        </li>

                        <li className="check-btn">
                            <label htmlFor="cat4">
                                <input type="checkbox" id="cat4" className="check-box" />
                                Science<span>(22)</span>
                            </label>
                        </li>

                        <li className="check-btn">
                            <label htmlFor="cat5">
                                <input type="checkbox" id="cat5" className="check-box" />
                                Medical<span>(15)</span>
                            </label>
                        </li>

                        <li className="check-btn">
                            <label htmlFor="cat6">
                                <input type="checkbox" id="cat6" className="check-box" />
                                Computer Applications<span>(16)</span>
                            </label>
                        </li>

                        <li className="check-btn">
                            <label htmlFor="cat7">
                                <input type="checkbox" id="cat7" className="check-box" />
                                Arts & Humanities<span>(12)</span>
                            </label>
                        </li>

                        <li className="check-btn">
                            <label htmlFor="cat8">
                                <input type="checkbox" id="cat8" className="check-box" />
                                Diploma Courses<span>(10)</span>
                            </label>
                        </li>

                    </ul>
                </div>
            </Styles>
        )
    }
}

export default CourseCategory
